import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { onMenuGroupSubmit } from "../../controller/SecurityController";
import 'react-toastify/dist/ReactToastify.css';
import toast, { Toaster } from 'react-hot-toast';
import AuthUtility from "../../util/AuthUtility";
import { MenuGroupModel } from "../../dto/MenuGroupModel";

const MenuGroup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!AuthUtility.isUserLoggedIn()) {
        navigate("/login");
        window.location.reload();
    }
  }, [])

  const [menuGroup, setMenuGroup] = useState<MenuGroupModel>({
    id: undefined,
    groupName: ''
  });

  const [error, setError] = useState('');

  const menuGroupSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const response = await onMenuGroupSubmit(menuGroup);
    if (response && response.error) {
      console.log(response);
      setError(response.error);
    } else {
        toast.success(response.msg);
    }
  }

  return (
    <div className="container">
        <div><Toaster position="top-right" reverseOrder={false}/></div>
            <div className="row justify-content-center">
                <div className="col-md-6 mt-3">
                    <div className="page-header">
                        <h3 className="mb-30"><a onClick={() => navigate(-1)}><big>&#8592;</big></a>Үндсэн цэс</h3>
                    </div>
                    <form onSubmit={menuGroupSubmit}>
                      <input type="hidden" />
                      <div className="mb-3 mt-3 row">
                        <label className="col-md-2 col-form-label">Нэр</label>
                        <div className="col-md-6">
                            <input type="text"
                            className="form-control"
                            value={menuGroup.groupName}
                            onChange={(event) => setMenuGroup({
                              id: undefined,
                              groupName: event.target.value
                            })}/>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-danger fw-500">Хадгалах</button>
                </form>
            </div>
        </div>
    </div>
  )
}

export default MenuGroup;